import axios from "axios";
import React, { use, useEffect, useState } from "react";
import { set } from "react-hook-form";
import { useOutletContext } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import useSmartBack from "../../hooks/useSmartBack";
function RoleNewView() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();
  const [options, setoptions] = useState([]);
  const [optionsLoaded, setOptionsLoaded] = useState(false);

  const navigate = useNavigate();
  const handleBack = useSmartBack("/role/list");

  useEffect(() => {
    async function fetchOptions() {
      setGlobalLoading(true); //  Show loader before API call
      try {
        const response = await axios.get(
          `${API_BASE_URL}/roles/get_roles_list_grid/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setoptions(response.data.backup_items_list || []);
        setOptionsLoaded(true);
      } catch (error) {
        console.error("API Error:", error);
        setoptions([]); // Prevent errors from breaking UI
        setOptionsLoaded(true);
      } finally {
        setOptionsLoaded(true);
        setGlobalLoading(false);
      }
    }
    fetchOptions();
  }, []);

  useEffect(() => {
    if (options.length > 0 || optionsLoaded) {
      setGlobalLoading(false);
      console.log(options);
    }
  }, [options]);

  return (
    <>
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Roles</h2>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
            <div className="me-2 mb-2">
              <div className="d-flex align-items-center border bg-warning rounded p-1 me-2 icon-list">
                <a
                  href="javascript:void(0);"
                  onClick={handleBack}
                  className="btn btn-icon btn-sm me-1"
                  title="Old View"
                >
                  <i className="ti ti-list-tree"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {options.length > 0 &&
            options.map((item, index) => (
              <div className="col-xxl-3 col-xl-3 col-md-6">
                <div
                  className="card"
                  onClick={() =>
                    navigate(
                      `/role/grid_view_user/${item.userId}`,
                    )
                  }
                  style={{ cursor: "pointer" }}
                >
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div className="d-flex align-items-center flex-shrink-0">
                        <a
                          href="javascript:void(0)"
                          className="avatar avatar-lg avatar rounded-circle me-2"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#candidate_details"
                        >
                          <img
                            src={`${PINE_BASE_URL}/files/media/${item.userpic}`}
                            className="img-fluid h-auto w-auto"
                            alt="img"
                          />
                        </a>
                        <div className="d-flex flex-column">
                          <div className="d-flex flex-wrap mb-1">
                            <h6 className="fs-16 fw-semibold me-1">
                              <a href="javascript:void(0)">{item.user}</a>
                            </h6>
                          </div>
                          <p className="text-gray fs-13 fw-normal">
                            {item.designation}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="bg-light rounder p-2">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <h6 className="text-gray fs-14 fw-normal">
                          Active Roles
                        </h6>
                        <span className="text-dark fs-14 fw-medium">
                          {item.total_roles}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
}

export default RoleNewView;
